import RootSaga from "./RootSaga";
import RootReducer from './RootReducer';
import createSagaMiddleware from "redux-saga";
import storage from 'redux-persist/lib/storage';
import { configureStore } from '@reduxjs/toolkit';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';

const persistConfig = {
    key: 'root',
    version: 5,
    storage,
};

const sagaMiddleware = createSagaMiddleware();
const loggerMiddleware = () => (next) => (action) => {
    const returnValue = next(action);
    return returnValue;
  };
const persistedReducer = persistReducer(persistConfig, RootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }
    ).concat(loggerMiddleware,sagaMiddleware)
});

sagaMiddleware.run(RootSaga);
const persistor = persistStore(store);

export { store, persistor };